<div class="desktop_config_icon">
  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>
  
    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>
  <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px">
      <div class="d-flex justify-content-between align-items-center my-2">
        <span style="width: 70% ;line-height: 1.4;">
          {{ 'chieu_cao_tong_vua_voi_bieu_tuong' | translate }}
        </span>
        <nz-switch [ngModel]="class.icon.height == 'auto'" 
          (ngModelChange)="class.icon.height = $event ? 'auto' : class.icon.width; updateClass()">
        </nz-switch>
      </div>
      
      <nz-select [ngModel]="staticdata.icon_type == 'icon' ? 'mat_icon' : staticdata.icon_type" (ngModelChange)="chooseTypeICon($event)">
        <nz-option nzValue="mat_icon" nzLabel="Icon"></nz-option>
        <nz-option nzValue="icon_svg" nzLabel="Icon Svg"></nz-option>
      </nz-select>

      <ng-container *ngIf="staticdata.icon_type == 'icon'">
        <div class="d-flex justify-content-between mx-1">
          <mat-icon [title]="objectChoosing.staticdata.icon">{{ objectChoosing.staticdata.icon }}</mat-icon>
          <button nz-button nzType="default" (click)="openDialogChooseIcon()" style="border-radius: 5px">
            {{ "thay_doi" | translate }}
          </button>
        </div>
    
        <div class="color-pick">
          <span class="title w-50">{{ "mau_bieu_tuong" | translate }}</span>
          <input class="input-color w-50" type="button" [cpOKButton]="true" [(colorPicker)]="class['icon']['color']"
            [style.background]="class['icon']['color']" (colorPickerClose)="updateObject()"
            [cpWidth]="'230px'" />
        </div>
      </ng-container>

      <ng-container *ngIf="staticdata.icon_type == 'icon_svg'">
        <div class="mt-2">
          <!-- Chọn nguồn để thêm icon svg -->
          <mat-form-field appearance="fill">
            <mat-label>{{'nguon_tep_svg_hien_thi_len' | translate}}</mat-label>
            <mat-select disableRipple 
            [ngModel]="staticdata.icon_svg_source ?? 'svg_code'" 
            (ngModelChange)="toggleIconSvgSource($event)">
              <mat-option value="upload">{{'tu_thiet_bi' | translate}}</mat-option>
              <mat-option value="url">{{'duong_dan_tep_svg' | translate}}</mat-option>
              <mat-option value="svg_code">{{'chuoi_ma_svg' | translate}}</mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Cấu hình upload từ thiết bị -->
          <div *ngIf="staticdata.icon_svg_source == 'upload'" class="input-group">
            <label>Upload</label>
            <input 
              id="upload-icon-svg" type="file"
              (change)="onFileSelected($event)" accept=".svg"
              style="line-height: 1.4;" class="w-100"
            >
          </div>
          
          <!-- Cấu hình nhập link svg -->
          <div *ngIf="staticdata.icon_svg_source == 'url'" class="input-group">
            <label>{{ 'nhap_duong_dan_tep_svg' | translate }}:</label>
            <textarea
              nz-input class="icon-svg-input px-2 w-100"
              style="resize: none;"
              placeholder="https://example.com/icon.svg"
              [nzAutosize]="{ minRows: 3, maxRows: 5 }"
              [ngModel]="staticdata.icon_svg_url"
              (ngModelChange)="staticdata.icon_svg_url = $event"
              (blur)="loadSvgFromUrl()"
            ></textarea>
          </div>

          <!-- Cấu hình nhập chuỗi code svg -->
          <textarea *ngIf="(staticdata.icon_svg_source || 'svg_code') == 'svg_code'"
            nz-input [(ngModel)]="staticdata.icon_svg" (blur)="updateStaticData()"
            placeholder="{{ 'them_chuoi_svg' | translate }} ..."
            [nzAutosize]="{ minRows: 3, maxRows: 5 }"
            style="resize: none;" class="icon-svg-input px-2"
          ></textarea>
        </div>
      </ng-container>
  
      <app-link-page-config
      [staticdata]="staticdata"
      [id_object]="objectChoosing._id"
      [dynamic_data]="objectChoosing.dynamic_data"
      ></app-link-page-config>
    </div>
  </ng-container>
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{
      currentViewAll.title | translate
      }}</span>
  </div>

  <ng-container *ngIf="!isViewAll && configMode == 'advanced'">

    <!-- thông số cơ bản -->
    <ul nz-menu nzMode="inline" *ngIf="!isViewAll" >
      <li nz-submenu nzTitle="{{ 'hien_thi' | translate }}" [(nzOpen)]="openMap.menu1.open"
        (nzOpenChange)="openHandler('menu1')">
        <div class="button-size">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li>

      <!-- bieu_tuong  -->
      <li nz-submenu nzTitle="{{ 'chon_loai_bieu_tuong' | translate }}" [(nzOpen)]="openMap.menu3.open"
        (nzOpenChange)="openHandler('menu3')">
        <nz-select [ngModel]="staticdata.icon_type == 'icon' ? 'mat_icon' : staticdata.icon_type" (ngModelChange)="chooseTypeICon($event)">
          <nz-option nzValue="mat_icon" nzLabel="Icon"></nz-option>
          <nz-option nzValue="icon_svg" nzLabel="Icon Svg"></nz-option>
        </nz-select>
        <div>
          <div class="d-flex justify-content-between align-items-center my-2">
            <span style="width: 70% ;line-height: 1.4;">
              {{ 'chieu_cao_tong_vua_voi_bieu_tuong' | translate }}
            </span>
            <nz-switch [ngModel]="class.icon.height == 'auto'" 
              (ngModelChange)="class.icon.height = $event ? 'auto' : class.icon.width; updateClass()">
            </nz-switch>
          </div>
          <ng-container *ngIf="staticdata.icon_type == 'icon' || staticdata.icon_type == 'mat_icon'">
            <li class="pl-2" nz-submenu nzTitle="{{ 'bieu_tuong' | translate }}"
              [(nzOpen)]="openMap.menu3.menuChild.menu9" (nzOpenChange)="openHandler('menu9')">
              <div>
                <div class="d-flex justify-content-between mx-1">
                  <mat-icon [title]="objectChoosing.staticdata.icon">{{ objectChoosing.staticdata.icon }}</mat-icon>
                  <button nz-button nzType="default" (click)="openDialogChooseIcon()" style="border-radius: 5px">
                    {{ "thay_doi" | translate }}
                  </button>
                </div>
  
                <!-- Màu biểu tượng -->
                <!-- <div class="d-flex justify-content-between mt-2 align-items-center">
              <p class="w-50">{{'mau_bieu_tuong' | translate}}</p>
              <input class="input-color w-50" type="button" [cpOKButton]="true" [(colorPicker)]="class['icon__primary']['color']"
                [style.background]="class['icon__primary']['color']" (colorPickerClose)="updateObject()" [cpWidth]="'230px'"
                [cpPositionRelativeToArrow]="true" />
            </div> -->
  
                <div class="color-pick">
                  <span class="title w-50">{{ "mau_bieu_tuong" | translate }}</span>
                  <input class="input-color w-50" type="button" [cpOKButton]="true" [(colorPicker)]="class['icon']['color']"
                    [style.background]="class['icon']['color']" (colorPickerClose)="updateObject()"
                    [cpWidth]="'230px'" />
                </div>
  
                <!-- Màu nền -->
                <!-- <div class="d-flex my-2 justify-content-between align-items-center">
              <p class="w-50">{{'mau_nen' | translate}}</p>
  
              <input class="input-color w-50" type="button" [cpOKButton]="true" [(colorPicker)]="class['icon']['background-color']"
                [style.background]="class['icon']['background-color']" (colorPickerClose)="updateClass()"
                [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" />
            </div> -->
                <div class="color-pick">
                  <span class="title w-50">{{ "mau_nen" | translate }}</span>
                  <input class="input-color w-50" type="button" [cpOKButton]="true" [(colorPicker)]="class['icon']['background-color']"
                    [style.background]="class['icon']['background-color']" (colorPickerClose)="updateObject()"
                    [cpWidth]="'230px'" />
                </div>
  
                <!-- Kích thước -->
                <ng-container>
                  <nz-row class="d-flex justify-content-between align-items-center">
                    <p class="m-0">{{ "kich_thuoc" | translate }}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="getFontSizeFromWidth()" [nzStep]="1" [ngStyle]="{ marginLeft: '10px' }"
                      [ngModel]="class['icon__primary']['font-size'] | vhnumber" 
                      (ngModelChange)="class['icon__primary']['font-size'] = $event + 'px'"
                      (nzBlur)="updateClass()"
                    ></nz-input-number>
                  </nz-row>
                  <nz-col nzSpan="24">
                    <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="1"
                      [ngModel]="class['icon__primary']['font-size'] | vhnumber" 
                      (ngModelChange)="class['icon__primary']['font-size'] = $event + 'px'"
                      (nzOnAfterChange)="updateClass()"
                    ></nz-slider>
                  </nz-col>
                </ng-container>
  
                <!-- Độ trong suốt -->
                <ng-container>
                  <nz-row class="d-flex justify-content-between align-items-center" nzSpan="24">
                    <p class="m-0">{{ "do_trong_suot" | translate }}</p>
                    <nz-input-number nzSpan="4" [nzMin]="0" [nzMax]="1" [ngModel]="class['icon']['opacity']"
                      (ngModelChange)="class['icon']['opacity'] = $event" (nzBlur)="updateClass()"
                      [nzStep]="0.1"></nz-input-number>
                  </nz-row>
                  <nz-col nzSpan="24">
                    <nz-slider [nzMin]="0" [nzMax]="1" [nzStep]="0.1" [ngModel]="class['icon']['opacity']"
                      (ngModelChange)="class['icon']['opacity'] = $event"
                      (nzOnAfterChange)="updateClass()"></nz-slider>
                  </nz-col>
                </ng-container>
  
                <!-- Độ nhòe -->
                <ng-container>
                  <nz-row class="d-flex justify-content-between align-items-center" nzSpan="24">
                    <p class="m-0">{{ "do_nhoe" | translate }}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="10" [nzStep]="1" [ngModel]="config['style_filter']['filter_blur']"
                      (ngModelChange)="updateFilter($event)" (nzBlur)="updateClass()">
                    </nz-input-number>
                  </nz-row>
                  <nz-slider [nzMin]="0" [nzMax]="10" [ngModel]="config['style_filter']['filter_blur']"
                    (ngModelChange)="updateFilter($event)" (nzOnAfterChange)="updateClass()">
                  </nz-slider>
                </ng-container>
              </div>
            </li>

            <!-- Lật hình  -->
            <li class="pl-2" nz-submenu nzTitle="{{ 'lat_hinh' | translate }}"
              [(nzOpen)]="openMap.menu3.menuChild.menu6" (nzOpenChange)="openHandler('menu6')">

              <div class="editor-field-body">
                <div class="mb-3">
                  <div class="field-row-sub">
                    <div style="display: flex; gap: 4px; width: 100%">
                      <span nz-button nzType="primary" nzSize="default" (click)="handleSetTransform('y')"
                        class="btn_transform">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                          <path fill="currentColor"
                            d="M15.97 15.25h-2.72c-5.3 0-9.5-2.15-9.5-4.5s4.2-4.5 9.5-4.5c3.03 0 5.82.7 7.62 1.86a.75.75 0 1 0 .81-1.26c-2.06-1.33-5.13-2.1-8.43-2.1-6.02 0-11 2.55-11 6s4.98 6 11 6h2.8l-2.3 2.3a.75.75 0 1 0 1.07 1.05l2.83-2.82c.68-.69.68-1.8 0-2.48l-2.83-2.83a.75.75 0 0 0-1.06 1.06l2.21 2.22z">
                          </path>
                        </svg>
                        <p class="m-0">{{ "ngang" | translate }}</p>
                      </span>
                      <button nz-button nzType="primary" nzSize="default" (click)="handleSetTransform('x')"
                        class="btn_transform">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                          <path fill="currentColor"
                            d="M15.25 8.35v2.4c0 5.3-2.15 9.5-4.5 9.5s-4.5-4.2-4.5-9.5c0-3.03.7-5.82 1.86-7.62a.75.75 0 1 0-1.26-.81c-1.33 2.06-2.1 5.13-2.1 8.43 0 6.02 2.55 11 6 11s6-4.98 6-11V8.27l2.3 2.3A.75.75 0 1 0 20.1 9.5l-2.82-2.83a1.75 1.75 0 0 0-2.48 0L11.97 9.5a.75.75 0 1 0 1.06 1.06l2.22-2.22z">
                          </path>
                        </svg>
                        <p class="m-0">{{ "doc" | translate }}</p>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="field-row mb-3">
                  <div class="field-row-sub">
                    <div style="display: flex; gap: 4px; width: 100%">
                      <button nz-button nzType="primary" nzSize="default" class="btn_transform"
                        (click)="handleSetTransform('-z')">
                        <span nz-icon nzType="rotate-left" nzTheme="outline"></span>
                        <p class="m-0">{{ "trai" | translate }}</p>
                      </button>
                      <button nz-button nzType="primary" nzSize="default" class="btn_transform"
                        (click)="handleSetTransform('z')">
                        <span nz-icon nzType="rotate-right" nzTheme="outline"></span>
                        <p class="m-0">{{ "phai" | translate }}</p>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mr-2 mb-4 mt-4 view-more" style="
                  display: flex;
                  align-items: center;
                  justify-content: flex-end;
                  gap: 7px;
                ">
                <p class="discover_text" (click)="openViewAll(styles_field[2])"
                  style="cursor: pointer; text-align: left; margin: 0">
                  {{ "mo_rong" | translate }} &#8594;
                </p>
              </div>
            </li>
          </ng-container>
          <li *ngIf="staticdata.icon_type == 'icon_svg'" class="pl-2" nz-submenu nzTitle="Icon SVG"
            [(nzOpen)]="openMap.menu3.menuChild.menu4" (nzOpenChange)="openHandler('menu4')">
            <!-- Chọn nguồn để thêm icon svg -->
            <mat-form-field appearance="fill">
              <mat-label>{{'nguon_tep_svg_hien_thi_len' | translate}}</mat-label>
              <mat-select disableRipple 
              [ngModel]="staticdata.icon_svg_source ?? 'svg_code'" 
              (ngModelChange)="toggleIconSvgSource($event)">
                <mat-option value="upload">{{'tu_thiet_bi' | translate}}</mat-option>
                <mat-option value="url">{{'duong_dan_tep_svg' | translate}}</mat-option>
                <mat-option value="svg_code">{{'chuoi_ma_svg' | translate}}</mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Cấu hình upload từ thiết bị -->
            <div *ngIf="staticdata.icon_svg_source == 'upload'" class="input-group">
              <label>Upload</label>
              <input 
                id="upload-icon-svg" type="file"
                (change)="onFileSelected($event)" accept=".svg"
                style="line-height: 1.4;" class="w-100"
              >
            </div>
            
            <!-- Cấu hình nhập link svg -->
            <div *ngIf="staticdata.icon_svg_source == 'url'" class="input-group">
              <label>{{ 'nhap_duong_dan_tep_svg' | translate }}:</label>
              <textarea
                nz-input class="icon-svg-input px-2 w-100"
                style="resize: none;"
                placeholder="https://example.com/icon.svg"
                [nzAutosize]="{ minRows: 3, maxRows: 5 }"
                [ngModel]="staticdata.icon_svg_url"
                (ngModelChange)="staticdata.icon_svg_url = $event"
                (blur)="loadSvgFromUrl()"
              ></textarea>
            </div>

            <!-- Cấu hình nhập chuỗi code svg -->
            <textarea *ngIf="(staticdata.icon_svg_source || 'svg_code') == 'svg_code'"
              nz-input [(ngModel)]="staticdata.icon_svg" (blur)="updateStaticData()"
              placeholder="{{ 'them_chuoi_svg' | translate }} ..."
              [nzAutosize]="{ minRows: 3, maxRows: 5 }"
              style="resize: none;" class="icon-svg-input px-2"
            ></textarea>
          </li>

          <!-- Kiểu viền và bo góc -->
          <li class="pl-2" nz-submenu nzTitle="{{ 'kieu_vien' | translate }}"
            [(nzOpen)]="openMap.menu3.menuChild.menu5" (nzOpenChange)="openHandler('menu5')">
            <app-borders-config [device]="device" [class]="class" [borderClass]="class['icon']"
              [id_object]="objectChoosing._id" [elementChoosing]="objectChoosing">
            </app-borders-config>

            <!-- Nút mở rộng -->
            <div class="item-border my-3" style="float: right">
              <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[0])">
                {{ "mo_rong" | translate }} &#8594;
              </p>
            </div>
          </li>

          <!-- Khoảng đệm -->
          <li class="pl-2" nz-submenu nzTitle="{{ 'khoang_dem' | translate }}"
            [(nzOpen)]="openMap.menu3.menuChild.menu11" (nzOpenChange)="openHandler('menu11')">
            <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
              [classPadding]="class['icon']" [paddingConfigs]="[
                { type: 'top' },
                { type: 'bottom' },
                { type: 'left' },
                { type: 'right' },
              ]">
            </app-padding-config>
          </li>

          <!-- Cấu hình hiệu ứng -->
          <li class="pl-2" nz-submenu nzTitle="{{ 'hieu_ung' | translate }}"
            [(nzOpen)]="openMap.menu3.menuChild.menu8" (nzOpenChange)="openHandler('menu8')">
            <app-choose-animations-config [type]="type" [elementChoosing]="objectChoosing" (openAnimationDetail)="openAnimationDetail($event)"
              [id_object]="objectChoosing._id" [device]="device" [class]="class" [config]="config" [staticdata]="staticdata"
              [cursorClass]="class['icon']" [effect_hover]="effect_hover" [customize]="customize" [type]="'object'"
              [effectFileUsing]="'icon'">
            </app-choose-animations-config>
          </li>

          <!-- Thêm liên kết cho trang  -->
          <li class="pl-2" nz-submenu nzTitle="{{ 'lien_ket' | translate }}"
            [(nzOpen)]="openMap.menu3.menuChild.menu7"
            (nzOpenChange)="openHandler('menu7')">
            <app-link-page-config
              [staticdata]="staticdata"
              [id_object]="objectChoosing._id"
              [dynamic_data]="objectChoosing.dynamic_data"
              [hasContact]="true"
              [blocks_of_page]="blocks_of_page"
            ></app-link-page-config>
          </li>

          <!-- VĂN BẢN GỢI Ý -->
          <li nz-submenu nzTitle="{{'van_ban_goi_y' | translate}}" class="pl-2"
            [(nzOpen)]="openMap.menu3.menuChild.menu10" (nzOpenChange)="openHandler('menu10')">
            <div class="editor-field my-0">
              <div class="editor-field-body">
                <div class="field-row my-0">
                  <!-- Nội dung chữ -->
                  <div class="config-font" style="width:100%">
                    <mat-form-field style="width:100%">
                      <mat-label>{{'noi_dung' | translate}}</mat-label>
                      <textarea style="height:80px;background: #edf6fd;
                        padding:10px 6px;font-size:13px;border-top-left-radius:5px;
                        border-top-right-radius:5px" matInput [(ngModel)]="config['tooltip']"
                        (blur)="updateConfig()"></textarea>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </div>
      </li>
    </ul>
  </ng-container>

  <!--Cấu hình hiệu ứng  -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết viền -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 1">
      <app-borders-radius-config [device]="device" [class]="class" [borderRadiusClass]="class['icon']"
        [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>
    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="currentViewAll.index == 2">
      <app-animations-config [type]="type" [elementChoosing]="objectChoosing" [staticdata]="staticdata" [id_object]="objectChoosing._id" [customize]="customize"
        [device]="device">
      </app-animations-config>
    </div>
    <!-- Cấu hình chi tiết lật hình -->
    <div class="editor-field-body p-0 mt-2" *ngIf="currentViewAll.index == 3">
      <div class="editor-field-body">
        <div class="field-row">
          <p style="font-weight: 500; font-size: 16px">
            {{ "lat_hinh" | translate }}
          </p>
          <div class="field-row-sub">
            <div style="display: flex; gap: 4px; width: 100%">
              <span nz-button nzType="primary" nzSize="default" (click)="handleSetTransform('y')" class="btn_transform">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                  <path fill="currentColor"
                    d="M15.97 15.25h-2.72c-5.3 0-9.5-2.15-9.5-4.5s4.2-4.5 9.5-4.5c3.03 0 5.82.7 7.62 1.86a.75.75 0 1 0 .81-1.26c-2.06-1.33-5.13-2.1-8.43-2.1-6.02 0-11 2.55-11 6s4.98 6 11 6h2.8l-2.3 2.3a.75.75 0 1 0 1.07 1.05l2.83-2.82c.68-.69.68-1.8 0-2.48l-2.83-2.83a.75.75 0 0 0-1.06 1.06l2.21 2.22z">
                  </path>
                </svg>
                <p class="m-0">{{ "ngang" | translate }}</p>
              </span>
              <button nz-button nzType="primary" nzSize="default" (click)="handleSetTransform('x')" class="btn_transform">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                  <path fill="currentColor"
                    d="M15.25 8.35v2.4c0 5.3-2.15 9.5-4.5 9.5s-4.5-4.2-4.5-9.5c0-3.03.7-5.82 1.86-7.62a.75.75 0 1 0-1.26-.81c-1.33 2.06-2.1 5.13-2.1 8.43 0 6.02 2.55 11 6 11s6-4.98 6-11V8.27l2.3 2.3A.75.75 0 1 0 20.1 9.5l-2.82-2.83a1.75 1.75 0 0 0-2.48 0L11.97 9.5a.75.75 0 1 0 1.06 1.06l2.22-2.22z">
                  </path>
                </svg>
                <p class="m-0">{{ "doc" | translate }}</p>
              </button>
            </div>
          </div>
        </div>
        <div class="field-row">
          <div class="item mt-2" style="min-height: 32px">
            <p class="m-0">{{ "ngang" | translate }}</p>
            <nz-input-number [nzMin]="-360" [nzMax]="360" [(ngModel)]="config['transform'].transform_rotateY"
              (ngModelChange)="SetTransform()" (nzBlur)="updateObject()">
            </nz-input-number>
          </div>
          <nz-slider [nzMin]="-360" [nzMax]="360" [(ngModel)]="config['transform'].transform_rotateY"
            (nzOnAfterChange)="updateObject()" (ngModelChange)="SetTransform()">
          </nz-slider>
        </div>
        <div class="field-row">
          <div class="item" style="min-height: 32px">
            <p class="m-0">{{ "doc" | translate }}</p>
            <nz-input-number [nzMin]="-360" [nzMax]="360" [(ngModel)]="config['transform'].transform_rotateX"
              (ngModelChange)="SetTransform()" (nzBlur)="updateObject()">
            </nz-input-number>
          </div>
          <nz-slider [nzMin]="-360" [nzMax]="360" [(ngModel)]="config['transform'].transform_rotateX"
            (nzOnAfterChange)="updateObject()" (ngModelChange)="SetTransform()">
          </nz-slider>
        </div>
      </div>
      <br />
      <!-- Xoay hình ảnh -->
      <div class="editor-field-body">
        <div class="field-row mb-3">
          <div style="justify-content: space-between; align-items: center">
            <p class="mt-1" style="font-weight: 500; font-size: 16px">
              {{ "xoay_hinh" | translate }}
            </p>
            <div style="display: flex; justify-content: space-between; gap: 4px">
              <button class="btn_transform" nz-button nzType="primary" nzSize="default"
                (click)="handleSetTransform('-z')">
                <span nz-icon nzType="rotate-left" nzTheme="outline"></span>
                <p class="m-0">{{ "trai" | translate }}</p>
              </button>
              <button nz-button nzType="primary" nzSize="default" class="btn_transform" (click)="handleSetTransform('z')">
                <span nz-icon nzType="rotate-right" nzTheme="outline"></span>
                <p class="m-0">{{ "phai" | translate }}</p>
              </button>
            </div>
          </div>
        </div>
        <div class="field-row">
          <div class="item" styl="min-height: 32px">
            <p class="m-0">{{ "xoay" | translate }}</p>
            <nz-input-number [nzMin]="-360" [nzMax]="360" [(ngModel)]="config['transform'].transform_rotateZ"
              (ngModelChange)="SetTransform()" (nzBlur)="updateObject()">
            </nz-input-number>
          </div>
          <nz-slider [nzMin]="-360" [nzMax]="360" [(ngModel)]="config['transform'].transform_rotateZ"
            (nzOnAfterChange)="updateObject()" (ngModelChange)="SetTransform()"></nz-slider>
        </div>
      </div>
      <br />
      <!-- Cấu hình Độ nghiêng -->
      <div class="editor-field-body">
        <div class="field-row mb-3">
          <div class="item">
            <p class="m-0" style="font-weight: 500; font-size: 16px">
              {{ "do_nghieng" | translate }}
            </p>
          </div>
        </div>
        <div class="field-row">
          <div class="item" style="min-height: 32px">
            <p class="m-0">{{ "ngang" | translate }}</p>
            <nz-input-number [nzMin]="-360" [nzMax]="360" [(ngModel)]="config['transform'].transform_skewY"
              (ngModelChange)="SetTransform()" (nzBlur)="updateObject()">
            </nz-input-number>
          </div>
          <nz-slider [nzMin]="-360" [nzMax]="360" [(ngModel)]="config['transform'].transform_skewY"
            (nzOnAfterChange)="updateObject()" (ngModelChange)="SetTransform()"></nz-slider>
        </div>
        <div class="field-row">
          <div class="item" style="min-height: 32px">
            <p class="m-0">{{ "doc" | translate }}</p>
            <nz-input-number [nzMin]="-360" [nzMax]="360" [(ngModel)]="config['transform'].transform_skewX"
              (ngModelChange)="SetTransform()" (nzBlur)="updateObject()">
            </nz-input-number>
          </div>
          <nz-slider [nzMin]="-360" [nzMax]="360" [(ngModel)]="config['transform'].transform_skewX"
            (nzOnAfterChange)="updateObject()" (ngModelChange)="SetTransform()"></nz-slider>
        </div>
      </div>
    </div>
  </div>
</div>
